import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

const { colors, spacing } = theme;

export default createUseStyles(
  {
    list: {
      padding: [spacing.sp01, 0],
      display: 'block',
    },

    hidden: {
      pointerEvents: 'none',
    },

    listWrapper: {
      borderRadius: 4,
      overflowY: 'auto',
      zIndex: 10,
      backgroundColor: colors.backgroundMenu,
      boxSizing: 'border-box',
      boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.125)', // TODO: token
    },

    trigger: {
      display: 'block',
    },

    narrow: {
      width: 180,
    },
    medium: {
      width: 300,
    },
    fullwidth: {
      width: '100%',
    },
  },
  {
    name: 'ContextualMenu',
  },
);
